"use client";

import { queryOptions } from "@tanstack/react-query";
import { GridRowId } from "@mui/x-data-grid-pro";

export const campaignAssigneesOptions = (campaignIds: GridRowId[]) => {
  return queryOptions({
    queryKey: ["campaignAssignees", { campaignIds }],
    queryFn: async (): Promise<
      {
        email: string;
        id: number;
      }[]
    > => {
      const searchParams = new URLSearchParams();
      campaignIds.forEach((id) => {
        searchParams.append("campaignIds", id.toString());
      });

      const response = await fetch(
        `/api/campaigns/assignees?${searchParams.toString()}`,
      );

      if (!response.ok) {
        throw new Error("Failed to fetch campaign assignees");
      }

      return response.json();
    },
    enabled: campaignIds.length > 0,
  });
};
